import React from "react";
// custom styled components
import { StyledContainer } from "./styledComponents";
// custom components
import FeaturedProduct from "../FeaturedProduct";
import Toast from "../Toast";
import Pokemons from "../Pokemons";
import Promotions from "../Promotions";

function Home() {
  return (
    <StyledContainer maxWidth="lg" component="main">
      <FeaturedProduct />
      <Promotions />
      <Pokemons />
      <Toast />
    </StyledContainer>
  );
}
export default Home;
